module.exports = __webpack_public_path__ + "img/06.06f82dda.png";